import { Col, ShoutoutsCol, Sidepanel, Spinner2 } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TopSection } from './components';

let interval;
const Game = ({ visible, closeModal, ev }) => {
  const [data, setData] = useState(ev),
    [trendingShoutouts, setTrendingShoutouts] = useState(null),
    [fetching, setFetching] = useState(true),
    [latestShoutouts, setLatestShoutouts] = useState(null),
    [hideCount, setHideCount] = useState(0),
    [listSelection, setListSelection] = useState(0),
    { users, text, location } = ev || {},
    shoutouts = useSelector((state) => state.shoutouts)
      ?.filter((x) => x.eventId === data?._id)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 10),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    { t } = useTranslation();

  useEffect(() => {
    if (!visible) return () => clearInterval(interval);

    setTimeout(() => fetchEvent(), 1000);

    /*
      Update game data every half minute
    */
    interval = setInterval(fetchEvent, 30000);

    return () => clearInterval(interval);
  }, [visible]);

  useEffect(() => {
    setData(ev);
  }, [ev]);

  function hideReactions() {
    setHideCount(hideCount + 1);
  }

  async function fetchEvent() {
    const res = await Api.get(`/games/getOne/${ev._id}`, { gameIds: [ev._id] });
    if (!res) return;

    const mappedTrending = res.trendingShoutouts
      .map((shoutout) => {
        if (typeof shoutout.from !== 'object') return null;
        return shoutout;
      })
      .filter((x) => x);

    const mappedLatest = res.latestShoutouts
      .map((shoutout) => {
        if (typeof shoutout.from !== 'object') return null;
        return shoutout;
      })
      .filter((x) => x);

    setData(res.data);
    setTrendingShoutouts(mappedTrending);
    setLatestShoutouts(mappedLatest);
    setFetching(false);

    dispatch({
      type: 'ADD_SHOUTOUTS',
      payload: [...mappedLatest, ...mappedTrending]
    });
  }

  function forwardOption(opt) {
    setListSelection(opt);
  }

  return (
    <Sidepanel visible={visible} closeModal={closeModal} pad="0" wid={617}>
      <Col bg="#fff" wid="100%">
        {(data || ev) && <TopSection data={data || ev} closeModal={closeModal} />}

        {fetching ? (
          <Col centerAll noFlex wid="100%" ht="500px">
            <Spinner2 col={theme.SECONDARY} />
          </Col>
        ) : (
          <Col
            wid={isMobile ? 'calc(100% - 32px)' : 'calc(100% - 48px)'}
            pad={isMobile ? '16px 16px' : '0 24px'}
          >
            <ShoutoutsCol
              forwardOption={forwardOption}
              data={listSelection === 0 ? trendingShoutouts : latestShoutouts}
            />
          </Col>
        )}
      </Col>
    </Sidepanel>
  );
};

export default Game;
